/**
 * @file: useTaskNavigation.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import type { AppNavParams } from '@euler/app/Routes';
import type { TaskNavParams } from '@euler/app/flows/task/TaskFlow';
import { useNavigation } from '@react-navigation/native';
import type { StackNavigationProp } from '@react-navigation/stack';

export const useTaskNavigation = () => {
  return useNavigation<StackNavigationProp<AppNavParams & TaskNavParams>>();
};
